import { ref } from 'vue'

export type Theme = 'system' | 'light' | 'dark'

const theme = ref<Theme>('system')

export const useTheme = () => {
  const applyTheme = () => {
    const html = document.documentElement
    
    if (theme.value === 'dark') {
      html.classList.add('dark')
    } else if (theme.value === 'light') {
      html.classList.remove('dark')
    } else {
      // System default
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        html.classList.add('dark')
      } else {
        html.classList.remove('dark')
      }
    }
  }

  const setTheme = (newTheme: Theme) => {
    theme.value = newTheme
    localStorage.setItem('theme', newTheme)
    applyTheme()
  }

  const initTheme = () => {
    // Load saved theme or default to 'system'
    const savedTheme = localStorage.getItem('theme') as Theme || 'system'
    theme.value = savedTheme
    applyTheme()

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleSystemThemeChange = () => {
      if (theme.value === 'system') {
        applyTheme()
      }
    }
    
    mediaQuery.addEventListener('change', handleSystemThemeChange)
    
    // Cleanup function
    return () => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange)
    }
  }

  return {
    theme,
    setTheme,
    initTheme,
    applyTheme
  }
}